import React from "react";
import { useIntl } from "react-intl";
// UI
import MaterialTable from "@material-table/core";
import _ from "lodash";

// Table Params
import { getColumns, OPTIONS, getLocalization } from "./GroupParams";
import { tableIcons } from "../../TableIcons";
import AuthenticationService from "../../../services/AuthenticationService";
import apiRequest from "../../../services/apiRequest";
import TableStyle from "../../../components/TableStyle";

function GroupsTable({
  groups,
  setGroups,
  toggleAddUserToGroupDialog,
  setSelectedGroup,
  push,
}) {
  const intl = useIntl();
  const scopes = AuthenticationService.getUserScopes();

  const _onRowUpdate = (newData, oldData) =>
    new Promise((resolve, reject) => {
      let isEqual = true;
      Object.entries(newData).forEach(([key, value]) => {
        if (oldData[key] !== value) {
          isEqual = false;
        }
      });
      setImmediate(() => {
        if (isEqual) {
          resolve();
        } else {
          apiRequest
            .post(`/groups/${oldData.id}`, newData)
            .then(() => {
              const newGroupList = groups.filter(
                (group) => group.id !== newData.id
              );
              newGroupList.push(newData);
              setGroups(newGroupList);
              push({
                title: intl.formatMessage({
                  id: "group_updated_successfully",
                }),
                type: "success",
              });
              resolve();
            })
            .catch(() => {
              push({
                title: intl.formatMessage({
                  id: "server_error",
                }),
                type: "error",
              });
              reject();
            });
        }
      });
    });

  const _onRowDelete = (newData) =>
    new Promise((resolve, reject) => {
      setImmediate(() => {
        apiRequest
          .delete(`/groups/${newData.id}`)
          .then(() => {
            const newGroupList = groups.filter(
              (group) => group.id !== newData.id
            );
            setGroups(newGroupList);
            push({
              title: intl.formatMessage({
                id: "group_deleted_successfully",
              }),
              type: "success",
            });
            resolve();
          })
          .catch(() => {
            push({
              title: intl.formatMessage({
                id: "server_error",
              }),
              type: "error",
            });
            reject();
          });
      });
    });

  return (
    <TableStyle>
      <MaterialTable
        columns={getColumns(intl)}
        data={groups}
        icons={tableIcons}
        isLoading={groups === undefined}
        options={OPTIONS}
        localization={getLocalization(intl)}
        onRowClick={(event, rowData) => {
          toggleAddUserToGroupDialog();
          setSelectedGroup(rowData.id);
        }}
        editable={{
          ...(scopes.indexOf("user:update") >= 0
            ? { onRowUpdate: _onRowUpdate }
            : {}),
          ...(scopes.indexOf("user:delete") >= 0
            ? { onRowDelete: _onRowDelete }
            : {}),
        }}
      />
    </TableStyle>
  );
}

export default React.memo(GroupsTable, (props, nextProps) => {
  // Render component only when props change
  return _.isEqual(props.groups, nextProps.groups);
});
